import { Routes } from "@angular/router";
import { OrdersPanelComponent } from "@features/orders/components/orders-panel/orders-panel.component";
import { ServicesPanelComponent } from "@features/services/components/services-panel/services-panel.component";
import { InvoiceTabComponent } from "@features/invoices/components/invoice-tab/invoice-tab.component";
import { MessagingComponent } from "@features/messaging/messaging.component";
import { NotSelectedTenantComponent } from "./layout/not-selected-tenant/not-selected-tenant.component";
import { MainLayoutComponent } from "./layout/main-layout/main-layout.component";
import { LoginComponent } from "@features/auth/components/login/login.component";
import { ForgotPasswordComponent } from "@features/auth/components/forgot-password/forgot-password.component";
import { authGuard } from "@features/auth/guards/auth.guard";
import { NotFoundComponent } from "@features/auth/components/not-found/not-found.component";

export const routes: Routes = [
  { path: "login", component: LoginComponent },
  { path: "forgot-password", component: ForgotPasswordComponent },
  {
    path: "",
    component: MainLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: "orders/:tenantId",
        children: [
          {
            path: "",
            component: OrdersPanelComponent,
          },
          {
            path: "",
            loadChildren: () =>
              import("@features/order-detail/order-detail.routes").then(
                (m) => m.orderDetailRoutes,
              ),
          },
        ],
      },
      { path: "messaging/:tenantId", component: MessagingComponent },
      { path: "services/:tenantId", component: ServicesPanelComponent },
      { path: "invoices/:tenantId", component: InvoiceTabComponent },
      {
        path: "components",
        loadChildren: () =>
          import("./features/examples/examples.routes").then(
            (m) => m.examplesRoutes,
          ),
      },
      {
        path: "search-stores/:tenantId",
        loadChildren: () =>
          import("./features/search-stores/search-stores.routes").then(
            (m) => m.searchStoresRoutes,
          ),
      },
      {
        path: "search-stores",
        loadChildren: () =>
          import("./features/search-stores/search-stores.routes").then(
            (m) => m.searchStoresRoutes,
          ),
      },
      {
        path: "stock-physical/:tenantId",
        loadChildren: () =>
          import("./features/stock-physical/stock-physical.routes").then(
            (m) => m.stockPhysicalRoutes,
          ),
      },
      {
        path: "stock-physical",
        loadChildren: () =>
          import("./features/stock-physical/stock-physical.routes").then(
            (m) => m.stockPhysicalRoutes,
          ),
      },
      { path: "orders", component: NotSelectedTenantComponent },
      { path: "messaging", component: NotSelectedTenantComponent },
      { path: "services", component: NotSelectedTenantComponent },
      { path: "invoices", component: NotSelectedTenantComponent },
      { path: "", redirectTo: "/orders", pathMatch: "full" },
    ],
  },
  { path: "**", component: NotFoundComponent },
];
